import { useState, type FormEvent } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { api } from '../../services/api.js';
import { Button, Input, Textarea } from '../ui/index.js';
import type { Scene } from '../../types/index.js';

interface SceneFormProps {
  projectId: string;
  scene?: Scene;
  onClose: () => void;
}

export function SceneForm({ projectId, scene, onClose }: SceneFormProps) {
  const qc = useQueryClient();
  const [name, setName] = useState(scene?.name ?? '');
  const [description, setDescription] = useState(scene?.description ?? '');

  const mutation = useMutation({
    mutationFn: async () => {
      if (scene) return api.put(`/scenes/${scene.id}`, { name, description });
      return api.post('/scenes', { projectId, name, description });
    },
    onSuccess: (result) => {
      if (!result.success) { toast.error(result.error); return; }
      qc.invalidateQueries({ queryKey: ['scenes', projectId] });
      toast.success(scene ? 'Scene updated' : 'Scene created');
      onClose();
    },
  });

  return (
    <form onSubmit={(e: FormEvent) => { e.preventDefault(); mutation.mutate(); }} className="space-y-4">
      <Input label="Scene name" value={name} onChange={e => setName(e.target.value)} placeholder="City Hall Exterior" required />
      <Textarea label="Notes (optional)" value={description} onChange={e => setDescription(e.target.value)} placeholder="Production notes, access info…" />
      <div className="flex gap-3 pt-2">
        <Button type="submit" loading={mutation.isPending} className="flex-1">{scene ? 'Save' : 'Create scene'}</Button>
        <Button type="button" variant="secondary" onClick={onClose} className="flex-1">Cancel</Button>
      </div>
    </form>
  );
}
